import script from "./FormElement.vue?vue&type=script&setup=true&lang=js"
export * from "./FormElement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__